// Put your application javascript here
//# sourceMappingURL=visibilityHandler.js.map
var process = process || {
    env: {
      NODE_ENV: "development",
    },
  },
  hidden,
  visibilityChange,
  titleInterval,
  initialDocumentTitle = document.title;

function createNewEvent(b) {
  if ("function" === typeof Event) var a = new Event(b);
  else (a = document.createEvent("Event")), a.initEvent(b, !0, !0);
  return a;
}
var pageHiddenEvent = createNewEvent("pageHidden");
"undefined" !== typeof document.hidden
  ? ((hidden = "hidden"), (visibilityChange = "visibilitychange"))
  : "undefined" !== typeof document.msHidden
  ? ((hidden = "msHidden"), (visibilityChange = "msvisibilitychange"))
  : "undefined" !== typeof document.webkitHidden &&
    ((hidden = "webkitHidden"), (visibilityChange = "webkitvisibilitychange"));
"undefined" !== typeof document.addEventListener &&
  "undefined" !== typeof document.hidden &&
  document.addEventListener(visibilityChange, handleVisibility, !1);

function handleVisibility() {
  document[hidden]
    ? (handleTitle(),
      (titleInterval = setInterval(handleTitle, 4e3)),
      null !== pageHiddenEvent &&
        (document.dispatchEvent(pageHiddenEvent), (pageHiddenEvent = null)))
    : (clearInterval(titleInterval),
      (titleInterval = null),
      (document.title = initialDocumentTitle));
}

function handleTitle() {
  document.title = "Your Beer Gift Awaits...";
  setTimeout(function () {
    null !== titleInterval && (document.title = "Trust QWERTY to deliver!");
  }, 2e3);
}
